module.exports = __webpack_public_path__ + "img/icon-undo.bfd16f21.svg";